import { useEffect } from 'react'
import AvailabilityForm from './AvailabilityForm'
import EventsStream from './EventsStream'
import OfferForm from './OfferForm'
import PositionsTable from './PositionsTable'
import ServiceModeController from './ServiceModeController'

import { useAuth } from '../contexts/AuthContext'

function Dashboard({ apiService, webSocketService }) {
  const { user, logout } = useAuth()

  // Ensure WebSocket connection when Dashboard mounts
  useEffect(() => {
    if (webSocketService && user && !webSocketService.isConnected) {
      console.log('Attempting WebSocket connection from Dashboard')
      webSocketService.connect().catch(error => {
        console.warn('WebSocket connection failed in Dashboard:', error)
      })
    }
  }, [webSocketService, user])

  return (
    <div className="dashboard">
      {/* Header */}
      <header className="MuiAppBar-root" style={{ 
        backgroundColor: '#1976d2', 
        color: 'white', 
        padding: '16px 24px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div>
          <h1 className="MuiTypography-h4" style={{ margin: 0, fontWeight: 300 }}>
            Energy Trade AI Trading Platform
          </h1>
          <p className="MuiTypography-subtitle1" style={{ margin: '4px 0 0 0', opacity: 0.9 }}>
            Flexible Aggregation for Energy Trading
          </p>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span className="MuiTypography-body1">
            Benvenuto, {user?.username || user?.email || 'Utente'}
          </span>
          <button 
            onClick={logout}
            className="MuiButton-root MuiButton-outlined" 
            style={{ 
              color: 'white', 
              borderColor: 'white', 
              padding: '8px 16px',
              backgroundColor: 'transparent'
            }}
          >
            Logout
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="dashboard-content" style={{ padding: '24px' }}>
        
        {/* Welcome Section */}
        <section className="MuiPaper-root MuiCard-root" style={{ padding: '24px', marginBottom: '24px' }}>
          <h2 className="MuiTypography-h5" style={{ color: '#1976d2', marginBottom: '16px' }}>
            Dashboard Overview
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div className="MuiPaper-root" style={{ padding: '16px', textAlign: 'center', backgroundColor: '#f5f5f5' }}>
              <h3 className="MuiTypography-h6" style={{ color: '#1976d2', margin: '0 0 8px 0' }}>Gestione Offerte</h3>
              <p className="MuiTypography-body2" style={{ color: '#666' }}>Crea e gestisci offerte sui mercati energetici</p>
            </div>
            <div className="MuiPaper-root" style={{ padding: '16px', textAlign: 'center', backgroundColor: '#f5f5f5' }}>
              <h3 className="MuiTypography-h6" style={{ color: '#1976d2', margin: '0 0 8px 0' }}>Monitoraggio</h3>
              <p className="MuiTypography-body2" style={{ color: '#666' }}>Visualizza posizioni e eventi in tempo reale</p>
            </div>
            <div className="MuiPaper-root" style={{ padding: '16px', textAlign: 'center', backgroundColor: '#f5f5f5' }}>
              <h3 className="MuiTypography-h6" style={{ color: '#1976d2', margin: '0 0 8px 0' }}>Analisi</h3>
              <p className="MuiTypography-body2" style={{ color: '#666' }}>Strumenti di analisi e reportistica avanzata</p>
            </div>
          </div>
        </section>

        {/* Service Mode Controller */}
        <ServiceModeController apiService={apiService} />

        {/* React Components */}
        <OfferForm apiService={apiService} />
        <AvailabilityForm apiService={apiService} />
        <PositionsTable apiService={apiService} wsService={webSocketService} />
        <EventsStream webSocketService={webSocketService} />
        
      </main>
    </div>
  )
}

export default Dashboard
